// 全局页面风格: 默认 / 暖色系 / 暗色系
// 实现方式: CSS filter 挂在 documentElement(html) 上
// - filter 会创建包含块, 挂 body 会波及 position:fixed 的弹窗/toast 定位;
//   挂 html 元素则 fixed 仍相对全屏定位, 无副作用
// - 暗色用 invert(1)+hue-rotate(180deg): 经典反色暗黑, hue-rotate 修正色相
// - 持久化: localStorage, 登录页同样生效(在 index.js 入口统一初始化)

const THEME_KEY = 'platform-theme';

const THEMES = {
  default: { label: '默认', filter: 'none' },
  warm: { label: '暖色系', filter: 'sepia(0.45) saturate(1.15)' },
  dark: { label: '暗色系', filter: 'invert(1) hue-rotate(180deg)' }
};

export const getTheme = () => {
  try {
    const t = localStorage.getItem(THEME_KEY);
    return THEMES[t] ? t : 'default';
  } catch (e) {
    return 'default';
  }
};

export const setTheme = (theme) => {
  const key = THEMES[theme] ? theme : 'default';
  try {
    localStorage.setItem(THEME_KEY, key);
  } catch (e) { /* 隐私模式等场景下忽略持久化 */ }
  applyTheme(key);
  return key;
};

export const applyTheme = (theme) => {
  const key = THEMES[theme] ? theme : 'default';
  const root = document.documentElement;
  if (key === 'default') {
    root.style.filter = '';
  } else {
    root.style.filter = THEMES[key].filter;
  }
  // 暗色系下图片/照片会变负片, 对 img 单独反转补回; SVG 图标(currentColor)无需处理
  if (key === 'dark') {
    root.setAttribute('data-theme', 'dark');
  } else {
    root.removeAttribute('data-theme');
  }
};

// 应用启动时调用(在 React 渲染前), 避免刷新瞬间主题闪烁
export const initTheme = () => {
  applyTheme(getTheme());
};

export const THEME_OPTIONS = Object.entries(THEMES).map(([key, v]) => ({
  key,
  label: v.label
}));
